import React, { useState, useRef, useEffect } from "react";
import { Bell, Settings, User, LogOut } from "lucide-react";
import "../styles/header.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearMenus } from "../redux/slices/permissionSlice";
import { clearUserInfo } from "../redux/userSlice"; 
import { RootState } from "../redux/slices/store";

const Header: React.FC = () => {
  const navigate = useNavigate();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const dispatch = useDispatch();
  const permissions = useSelector((state: RootState) => state.permissions);
  // Get user information from Redux store
  const userInfo = useSelector((state: RootState) => state.user);

  useEffect(() => {
    console.log("after clearing menus: ", permissions);
  }, [permissions]);

  const handleLogOut = () => {
    dispatch(clearMenus());
    dispatch(clearUserInfo()); // Clear user info on logout
    localStorage.removeItem("authToken");
    navigate("/login");
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <header className="header">
      <div className="header-heading">
        <h1>AgamHive</h1>
      </div>
      <div className="header-right">
        <Settings className="header-icon" />
        <Bell className="header-icon" />
        <div className="header-profile-container" ref={dropdownRef}>
          <div className="header-profile" onClick={toggleDropdown}>
            <img
              src="/images/profile.png"
              alt="User Profile"
              className="profile-image"
            />
            <div className="profile-info">
              <span className="user-name">
                {userInfo.isLoggedIn ? `${userInfo.firstName} ` : "Jhon Wick"}
              </span>
              
            </div>
          </div>

          {isDropdownOpen && (
            <div className="profile-dropdown">
              {/* <div className="dropdown-item" onClick={() => navigate('/profile')}>
                <User size={16} />
                <span>Show Profile</span>
              </div>
              
              <div className="dropdown-item" onClick={() => navigate('/settings')}>
                <Settings size={16} />
                <span>Settings</span>
              </div> */}
              <div className="dropdown-item logout" onClick={handleLogOut}>
                <LogOut size={16} />
                <span>Sign out</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;